export const POLLING_TIMEOUT_LIMIT = 30000;
export const SHORT_POLLING_TIMEOUT_LIMIT = 5000;

export const POLLING_INTERVAL = 500;

export const PollEndpointStatuses = {
  SUCCEEDED: 'succeeded',
  IN_PROGRESS: 'in_progress',
  FAILED: 'failed',
} as const;
